import { format } from 'date-fns'
import CommentBody from '../ui/CommentBody'
import {
    extractLegacyCommentImages,
    getInitials,
    isImageAttachment,
    stripLegacyImageLines,
} from './cardDetailUtils'

export default function CardCommentItem({
    t,
    comment,
    isReply = false,
    comments,
    attachments,
    currentUserId,
    editingCommentId,
    editingCommentText,
    setEditingCommentId,
    setEditingCommentText,
    updateComment,
    showAchievement,
    openLightbox,
    setPreviewFile,
}) {
    const isOwn = comment.user_id === currentUserId
    const isEditing = editingCommentId === comment.id
    const linkedImages = attachments.filter((att) => att.comment_id === comment.id && isImageAttachment(att))
    const legacyImages = extractLegacyCommentImages(comment.text)
    const commentImages = [...linkedImages]
    for (const legacy of legacyImages) {
        if (!commentImages.some((att) => att.url === legacy.url)) commentImages.push(legacy)
    }
    const displayText = stripLegacyImageLines(comment.text)
    const replies = comments.filter((x) => x.parent_comment_id === comment.id)

    return (
        <div key={comment.id} className={`comment-item ${isReply ? 'comment-item-reply' : ''}`.trim()}>
            <div
                className={`comment-avatar ${isOwn ? 'comment-avatar-self' : 'comment-avatar-other'}`}
                title={comment.profiles?.full_name || t('card.comments.unknownAuthor')}
                aria-label={comment.profiles?.full_name || t('card.comments.unknownAuthor')}
            >
                {getInitials(comment.profiles?.full_name)}
            </div>
            <div className="comment-content">
                {isEditing ? (
                    <>
                        <div className="comment-header">
                            <span className="comment-date">{format(new Date(comment.created_at), 'dd MMM, HH:mm')}</span>
                        </div>
                        <div className="comment-edit">
                            <textarea
                                className="comment-edit-input"
                                value={editingCommentText}
                                onChange={(e) => setEditingCommentText(e.target.value)}
                                rows={3}
                                autoFocus
                            />
                            <div className="comment-edit-actions">
                                <button type="button" className="comment-edit-cancel" onClick={() => { setEditingCommentId(null); setEditingCommentText('') }}>
                                    {t('common.cancel')}
                                </button>
                                <button
                                    type="button"
                                    className="comment-edit-save"
                                    onClick={async () => {
                                        const text = editingCommentText.trim()
                                        if (!text) return
                                        const res = await updateComment(comment.id, text)
                                        if (res.success) {
                                            setEditingCommentId(null)
                                            setEditingCommentText('')
                                        } else {
                                            showAchievement({ type: 'error', message: res.error })
                                        }
                                    }}
                                >
                                    {t('common.save')}
                                </button>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="comment-message-row">
                            {displayText ? (
                                <div className="comment-body"><CommentBody text={displayText} attachments={attachments} onPreviewFile={setPreviewFile} /></div>
                            ) : null}
                            <span className="comment-date">{format(new Date(comment.created_at), 'dd MMM, HH:mm')}</span>
                        </div>
                        {commentImages.length > 0 ? (
                            <div className="comment-image-grid">
                                {commentImages.map((image, index) => (
                                    <button
                                        key={`${image.id || image.url}-${index}`}
                                        type="button"
                                        className="comment-image-thumb"
                                        onClick={() => openLightbox(commentImages, index)}
                                        title={image.name || 'Imagine'}
                                    >
                                        <img src={image.url} alt={image.name || 'Imagine'} />
                                    </button>
                                ))}
                            </div>
                        ) : null}
                        {replies.length > 0 && (
                            <div className="comment-replies">
                                {replies.map((reply) => (
                                    <CardCommentItem
                                        key={reply.id}
                                        t={t}
                                        comment={reply}
                                        isReply
                                        comments={comments}
                                        attachments={attachments}
                                        currentUserId={currentUserId}
                                        editingCommentId={editingCommentId}
                                        editingCommentText={editingCommentText}
                                        setEditingCommentId={setEditingCommentId}
                                        setEditingCommentText={setEditingCommentText}
                                        updateComment={updateComment}
                                        showAchievement={showAchievement}
                                        openLightbox={openLightbox}
                                        setPreviewFile={setPreviewFile}
                                    />
                                ))}
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    )
}
